'use strict';

/* globals urls */

var $ = require('jquery');

var company = $('body').data('client');
$('.company-field').hide().find('input').val(company);

